<template>
  <div id="bearse-features">
    <div class="row">
      <div class="col-4">
        <transition name="fade" appear>
          <div class="card" style="min-height: 310px;">
            <div class="card-header">
              <h5 class="d-flex justify-content-between align-items-center">
                bearse feature {{activeFeature}}
                <div class="nav-item btn-group dropdown">
                  <button type="button" class="btn-block btn dropdown-toggle btn-secondary" style="margin-right: 10px;" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{activeFeature}}
                  </button>
                  <div class="dropdown-menu dropdown-menu-right scrollable-menu">
                    <h6 class="dropdown-header">Bearse Features</h6>
                    <div v-for="feature of listFeaturesWithCount(features, report)" :key="feature.name">
                      <a class="dropdown-item d-flex" @click="activeFeature=feature.name">
                        <span style="margin-right: 15px;">{{ feature.name }}</span>
                        <span :class="[feature.count > 0 ? 'badge-primary' : 'badge-secondary']" class="badge badge-pill ml-auto">{{ feature.count }}</span>
                      </a>
                    </div>
                  </div>
                </div>
              </h5>
            </div>

            <div class="card-body">
              <dl>
                <dt>Latest Version</dt><dd>{{features[activeFeature].latest}}</dd>
                <dt>Minimum Version</dt><dd>{{features[activeFeature].minimum}}</dd>
                <dt>Source</dt><dd><a :href="features[activeFeature].source">{{features[activeFeature].source}}</a></dd>
                <dt>Open Source</dt><dd>{{features[activeFeature].opensource}}</dd>
              </dl>
            </div>
          </div>
        </transition>
      </div>
      <div class="col-8">
        <transition name="fade" appear>
          <vue-good-table
            :columns="accountsTable"
            :rows="accounts"
            :pagination-options="{
              enabled: true,
              perPage: 5,
            }"
            styleClass="vgt-table condensed">
          </vue-good-table>
        </transition>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <vue-good-table
          :columns="featureTable"
          :rows="selectFeature(report, activeFeature)"
          :search-options="{
            enabled: true,
            skipDiacritics: true,
            placeholder: 'filter',
          }"
          :pagination-options="{
            enabled: true,
            perPage: 20,
          }"
          styleClass="vgt-table condensed">
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BearseFeatures',
  props: [
    'report',
    'features',
    'templates',
    'accounts',
    'accountsReporting'
  ],
  data () {
    return {
      activeFeature: 'reporting',
      accountsTable: [
        {
          label: 'Contract',
          field: 'contract'
        },
        {
          label: 'Account Name',
          field: 'account_name'
        },
        {
          label: 'Account Id',
          field: 'account_id'
        },
        {
          label: 'Access Template',
          field: 'access_template'
        },
        {
          label: 'Execution Template',
          field: 'execution_template'
        },
        {
          label: 'Monitored',
          field: 'account_monitored'
        },
        {
          label: 'Last Report Date',
          field: 'report_date',
          type: 'date',
          dateInputFormat: 't',
          dateOutputFormat: 'MMM do yyyy KK:mm a'
        }
      ],
      featureTable: [
        {
          label: 'Contract',
          field: 'contract'
        },
        {
          label: 'Account Name',
          field: 'account_name'
        },
        {
          label: 'Account Id',
          field: 'account_id'
        },
        {
          label: 'Region',
          field: 'region'
        },
        {
          label: 'Feature',
          field: 'feature'
        },
        {
          label: 'Stack',
          field: 'stack'
        },
        {
          label: 'Version',
          field: 'version'
        },
        {
          label: 'State',
          field: 'state'
        },
        {
          label: 'Stack Updated',
          field: 'last_update',
          type: 'date',
          dateInputFormat: 't',
          dateOutputFormat: 'MMM do yyyy KK:mm a'
        },
        {
          label: 'Reported',
          field: 'timestamp',
          type: 'date',
          dateInputFormat: 't',
          dateOutputFormat: 'MMM do yyyy KK:mm a'
        }
      ]
    }
  },
  methods: {
    selectFeature: function (report, featureName) {
      return report.filter(item => item.feature === featureName)
    },
    listFeaturesWithCount: function (features, report) {
      var objs = Object.keys(features).map(feature => {
        var featuresFound = report.filter(item => item.feature === feature)
        var count = featuresFound.length
        return { name: feature, count: count }
      })
      return objs.sort((a, b) => b.count - a.count)
    }
  }
}
</script>

<style scoped>
.card {
  transition: opacity 200ms;
  background: #ffffff;
  width: auto;
  border: none;
  border-radius: 0;
  box-sizing: content-box;
  box-shadow: 0 2px 13px -5px rgba(0,0,0,0.2);
  margin-bottom: 15px;
}

.card-header {
  background: #ffffff;
  border: none;
}

dl {
  display: grid;
  grid-template-columns: max-content auto;
}

dt {
  grid-column-start: 1;
  margin-right: 10px;
}

dd {
  grid-column-start: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/Tools/BearseFeatures.vue